import React, { useState } from 'react';
import ListarRegionales from './ListarRegionales';
import RegistrarRegionales from './RegistrarRegionales' ;

const Regional = () => {
  const [refresh, setRefresh] = useState(false); 

  const actualizarRegionales = () => {
    setRefresh(prev => !prev);  // Cambia el estado para forzar la actualización
  };

  return (
    <div>
      <RegistrarRegionales actualizarRegionales={actualizarRegionales} />
      <ListarRegionales refresh={refresh} />
    </div>
  );
};

export default Regional;
